const $ = require('jquery')

const pageTopBarOffset = -100

module.exports = function scrollToFirstError() {
  const form = document.getElementById('vlt-form-container')

  $(form).ready(() => {
    const errors = $(form).find('.has-error')

    if (errors.length > 0) {
      window.scrollTo({
        top: errors[0].getBoundingClientRect().top + window.pageYOffset + pageTopBarOffset,
        behavior: 'smooth',
      })
    }
  })
}
